module.exports = __webpack_public_path__ + "static/media/moons_advanced-960.8cb8a242.webp";